module.exports = __webpack_public_path__ + "img/logo-text-dark-mode.99ce5df0.png";